// extracted by css-extract-rspack-plugin
module.exports =  {"scoring":"Scoring-UUPl__scoring"};